import { IconButton } from 'bricks-ui/packages/bricks-ui';

export default IconButton;
